import type {
  EventRegistrationCandidateStatus,
  EventRegistrationExperienceLevel,
} from '@/lib/event/registration-options'

export type SupportedLocale = 'en' | 'id'

export const WEBINAR_COPY = {
  en: {
    navTitle: 'CAREER PREP.',
    liveSoon: 'LIVE SOON',
    badge: 'Ngabuburit Career Webinar Series',
    title: 'Job Search Strategy Without Applying Hundreds of Times',
    description:
      'A free webinar to help you find jobs that match your skills through a more focused and effective process.',
    scheduleTitle: 'Webinar Schedule',
    scheduleDateLabel: 'Date',
    scheduleDateValue: 'Saturday, April 25, 2026',
    scheduleTimeLabel: 'Time',
    scheduleTimeValue: '7:00 PM WIB, until finish',
    scheduleLocationLabel: 'Location',
    scheduleLocationValue: 'Online via Zoom',
    limitedSeats: 'For the first 100 registrants only.',
    countdownLabel: 'Registration closing in',
    countdownUnits: {
      days: 'Days',
      hours: 'Hrs',
      minutes: 'Mins',
      seconds: 'Secs',
    },
    instructorTitle: 'Career Mentor',
    instructorName: 'Gandhi Surya Buana',
    instructorRole: 'Recruitment Consultant & Labour Market Intelligence Research',
    instructorDescription:
      'Helping candidates understand recruitment processes and job-search strategy based on labor market data.',
    topicsTitle: 'TOPICS COVERED',
    topics: [
      {
        title: 'CV That Passes ATS Screening',
        description:
          'How to craft an ATS-friendly CV that is relevant to your target role.',
      },
      {
        title: 'CV-to-Job Match Score',
        description:
          'How to evaluate whether your CV matches a specific job opening.',
      },
      {
        title: '"Cheat Sheet" for Smoother Interviews',
        description:
          'How to create an interview "cheat sheet" so your answers are more structured.',
      },
    ],
    bonusTag: 'FREE BONUS',
    bonusTitle: 'CAREER CHECKUP',
    bonusDescription:
      'For the first 100 registrants, you will get a checkup to assess CV-ATS quality, CV fit for your target role, your interview answer quality, and strategies tailored to your CV and target position.',
    trustTitle: 'Trusted by teams at',
    sideCtaTitle: 'Ready to join the webinar?',
    sideCtaDescription:
      'Fill in the form to secure your seat and get webinar updates via WhatsApp.',
    sideCtaBenefits: [
      'Live webinar access',
      'Free Career Checkup',
      'WhatsApp reminder updates',
    ],
    formTitle: 'Register for the Webinar',
    formDescription:
      'Fill in your details to register for Saturday, April 25, 2026 and receive important updates via WhatsApp.',
    nameLabel: 'Full Name',
    namePlaceholder: 'Jane Doe',
    emailLabel: 'Email Address',
    emailPlaceholder: 'jane@email.com',
    phoneLabel: 'WhatsApp Number',
    phonePlaceholder: '+62 812 3456 7890',
    experienceLevelLabel: 'Experience Level',
    experienceLevelPlaceholder: 'Select your experience level',
    candidateStatusLabel: 'Current Status',
    candidateStatusPlaceholder: 'Select your current status',
    requiredField: 'This field is required.',
    submit: 'Register Now + Free Career Checkup',
    submitting: 'Submitting...',
    thankYouTitle: "You're In!",
    thankYouDescription:
      'All webinar information will be sent via WhatsApp group. Join the group and check it regularly.',
    thankYouStepsTitle: 'Do This Now',
    thankYouStepOneTitle: 'Join WhatsApp Group',
    thankYouStepOneDescription:
      'All updates, Zoom link, reminders, and announcements will be shared in the WhatsApp group.',
    thankYouStepOneCta: 'Join WhatsApp Group',
    thankYouStepTwoTitle: 'Check Group Regularly',
    thankYouStepTwoDescription:
      'Check the group regularly so you do not miss important webinar updates.',
    thankYouStepTwoPoints: [
      'Reminder and schedule updates',
      'Zoom link before session starts',
      'Latest announcements from the Hyred team',
    ],
    thankYouStepTwoCta: 'Free CV Review',
    thankYouNextTitle: 'Important Reminder',
    thankYouNextWebinarTitle: 'All webinar information is in WhatsApp group',
    thankYouNextWebinarDescription:
      'Date, time, Zoom link, reminders, and all latest updates will be shared via WhatsApp group.',
    thankYouNextInboxTitle: 'Join and check regularly',
    thankYouNextInboxDescription:
      'Join the group now and check it regularly until webinar day.',
    thankYouSupport:
      'If you have trouble joining the group, use the WhatsApp button above to contact our team.',
    backToWebinar: 'Back to webinar page',
    successTitle: 'Registration submitted',
    successDescription:
      'Your registration is saved. If WhatsApp did not open automatically, use the button below.',
    openWhatsapp: 'Open WhatsApp Link',
    submitErrorTitle: 'Submission failed',
    submitErrorFallback: 'Registration failed. Please try again.',
  },
  id: {
    navTitle: 'CAREER PREP.',
    liveSoon: 'LIVE SOON',
    badge: 'Ngabuburit Career Webinar Series',
    title: 'Strategi Cari Kerja Tanpa Apply Ratusan Kali',
    description:
      'Webinar gratis untuk bantu kamu mencari kerja sesuai skill dengan proses yang lebih terarah dan efektif.',
    scheduleTitle: 'Jadwal Webinar',
    scheduleDateLabel: 'Tanggal',
    scheduleDateValue: 'Sabtu, 25 April 2026',
    scheduleTimeLabel: 'Waktu',
    scheduleTimeValue: '19.00 WIB sampai selesai',
    scheduleLocationLabel: 'Platform',
    scheduleLocationValue: 'Online via Zoom',
    limitedSeats: 'Khusus 100 orang pertama.',
    countdownLabel: 'Pendaftaran ditutup dalam',
    countdownUnits: {
      days: 'Hari',
      hours: 'Jam',
      minutes: 'Menit',
      seconds: 'Detik',
    },
    instructorTitle: 'Career Mentor',
    instructorName: 'Gandhi Surya Buana',
    instructorRole: 'Recruitment Consultant & Labour Market Intelligence Research',
    instructorDescription:
      'Membantu kandidat memahami proses rekrutmen dan strategi job search berbasis data pasar kerja.',
    topicsTitle: 'TOPIK BAHASAN',
    topics: [
      {
        title: 'CV Lolos Screening ATS',
        description:
          'Cara menyusun CV ATS-friendly yang relevan dengan posisi yang kamu incar.',
      },
      {
        title: 'Skor Kecocokan CV dengan Lowongan',
        description:
          'Cara menilai apakah CV kamu sudah cocok dengan lowongan.',
      },
      {
        title: '“Contekan” Interview Biar Lancar',
        description:
          'Cara buat “contekan” interview biar jawab lebih terstruktur.',
      },
    ],
    bonusTag: 'BONUS GRATIS',
    bonusTitle: 'CAREER CHECKUP',
    bonusDescription:
      'Khusus 100 orang pertama, akan mendapatkan checkup untuk mengecek kualitas CV-ATS, kecocokan CV dengan posisi yang kamu lamar, kualitas jawaban interviewmu, dan strategi sesuai CV serta posisimu.',
    trustTitle: 'Dipercaya tim dari',
    sideCtaTitle: 'Siap ikut webinarnya?',
    sideCtaDescription:
      'Isi form untuk amankan kursi dan dapatkan update webinar via WhatsApp.',
    sideCtaBenefits: [
      'Akses webinar live',
      'Career Checkup gratis',
      'Update pengingat lewat WhatsApp',
    ],
    formTitle: 'Daftar Webinar Sekarang',
    formDescription:
      'Isi data berikut untuk mendaftar webinar Sabtu, 25 April 2026 dan menerima update penting via WhatsApp.',
    nameLabel: 'Nama Lengkap',
    namePlaceholder: 'Nama lengkap',
    emailLabel: 'Email',
    emailPlaceholder: 'email@contoh.com',
    phoneLabel: 'Nomor WhatsApp',
    phonePlaceholder: '0812 3456 7890',
    experienceLevelLabel: 'Level Pengalaman',
    experienceLevelPlaceholder: 'Pilih level pengalaman',
    candidateStatusLabel: 'Status Saat Ini',
    candidateStatusPlaceholder: 'Pilih status saat ini',
    requiredField: 'Kolom ini wajib diisi.',
    submit: 'Daftar Webinar + Career Checkup Gratis',
    submitting: 'Mengirim...',
    thankYouTitle: 'Kamu Sudah Terdaftar!',
    thankYouDescription:
      'Semua informasi webinar akan dikirim lewat grup WhatsApp. Gabung grupnya dan cek secara berkala.',
    thankYouStepsTitle: 'Lakukan Ini Sekarang',
    thankYouStepOneTitle: 'Gabung Grup WhatsApp',
    thankYouStepOneDescription:
      'Semua update, link Zoom, reminder, dan pengumuman akan dibagikan di grup WhatsApp.',
    thankYouStepOneCta: 'Gabung Grup WhatsApp',
    thankYouStepTwoTitle: 'Sambil Tunggu Webinar, Review CVmu Gratis',
    thankYouStepTwoDescription:
      'Sambil menunggu jadwal webinar, cek fitur Review CV Gratis untuk cek kualitas CV kamu.',
    thankYouStepTwoPoints: [
      'Upload CV dan dapatkan evaluasi cepat',
      'Lihat bagian CV yang perlu diperbaiki',
      'Datang ke webinar dengan CV yang lebih siap',
    ],
    thankYouStepTwoCta: 'Review CV Gratis',
    thankYouNextTitle: 'Pengingat Penting',
    thankYouNextWebinarTitle: 'Semua informasi webinar ada di grup WhatsApp',
    thankYouNextWebinarDescription:
      'Tanggal, jam, link Zoom, reminder, dan update terbaru akan dibagikan lewat grup WhatsApp.',
    thankYouNextInboxTitle: 'Gabung lalu cek secara berkala',
    thankYouNextInboxDescription:
      'Gabung grup sekarang lalu cek secara berkala sampai hari webinar.',
    thankYouSupport:
      'Kalau ada kendala gabung grup, gunakan tombol WhatsApp di atas untuk hubungi tim kami.',
    backToWebinar: 'Kembali ke halaman webinar',
    successTitle: 'Pendaftaran berhasil dikirim',
    successDescription:
      'Data kamu sudah tersimpan. Jika WhatsApp belum terbuka otomatis, gunakan tombol di bawah.',
    openWhatsapp: 'Buka Link WhatsApp',
    submitErrorTitle: 'Gagal mengirim',
    submitErrorFallback: 'Pendaftaran gagal dikirim. Silakan coba lagi.',
  },
} as const

export const resolveWebinarLocale = (value: unknown): SupportedLocale =>
  value === 'en' ? 'en' : 'id'

export const EXPERIENCE_LEVEL_LABELS: Record<
  SupportedLocale,
  Record<EventRegistrationExperienceLevel, string>
> = {
  en: {
    'Fresh Graduate without Internship Experience':
      'Fresh Graduate (No Internship)',
    'Fresh Graduate with Internship Experience':
      'Fresh Graduate (With Internship)',
    '0-1 Years of Professional Experience': '0-1 Years of Professional Experience',
    '1-3 Years of Professional Experience': '1-3 Years of Professional Experience',
    '3-5 Years of Professional Experience': '3-5 Years of Professional Experience',
    '5-10 Years of Professional Experience': '5-10 Years of Professional Experience',
  },
  id: {
    'Fresh Graduate without Internship Experience': 'Fresh Graduate (Tanpa Magang)',
    'Fresh Graduate with Internship Experience': 'Fresh Graduate (Dengan Magang)',
    '0-1 Years of Professional Experience': '0-1 Tahun Profesional',
    '1-3 Years of Professional Experience': '1-3 Tahun Profesional',
    '3-5 Years of Professional Experience': '3-5 Tahun Profesional',
    '5-10 Years of Professional Experience': '5-10 Tahun Profesional',
  },
}

export const CANDIDATE_STATUS_LABELS: Record<
  SupportedLocale,
  Record<EventRegistrationCandidateStatus, string>
> = {
  en: {
    'Masih kuliah, persiapan cari kerja':
      'Still in college, preparing for job search',
    'Sedang Bekerja, aktif mencari peluang baru':
      'Currently employed, actively seeking new opportunities',
    'Tidak Bekerja, mencari kerja kurang dari 3 bulan':
      'Unemployed, job searching for less than 3 months',
    'Tidak Bekerja, mencari kerja 3-6 bulan':
      'Unemployed, job searching for 3-6 months',
    'Tidak Bekerja, mencari kerja 6-12 bulan':
      'Unemployed, job searching for 6-12 months',
    'Tidak Bekerja, mencari kerja 12-24 bulan':
      'Unemployed, job searching for 12-24 months',
    'Tidak Bekerja, mencari kerja lebih dari 24 bulan':
      'Unemployed, job searching for more than 24 months',
  },
  id: {
    'Masih kuliah, persiapan cari kerja': 'Masih kuliah, persiapan cari kerja',
    'Sedang Bekerja, aktif mencari peluang baru':
      'Sedang Bekerja, aktif mencari peluang baru',
    'Tidak Bekerja, mencari kerja kurang dari 3 bulan':
      'Tidak Bekerja, mencari kerja kurang dari 3 bulan',
    'Tidak Bekerja, mencari kerja 3-6 bulan':
      'Tidak Bekerja, mencari kerja 3-6 bulan',
    'Tidak Bekerja, mencari kerja 6-12 bulan':
      'Tidak Bekerja, mencari kerja 6-12 bulan',
    'Tidak Bekerja, mencari kerja 12-24 bulan':
      'Tidak Bekerja, mencari kerja 12-24 bulan',
    'Tidak Bekerja, mencari kerja lebih dari 24 bulan':
      'Tidak Bekerja, mencari kerja lebih dari 24 bulan',
  },
}
